export default __webpack_public_path__ + "static/media/dankort.bc04e18c.svg";